import { filterSubsectionsByName } from '../utils';
import { BulletPointsProps } from './components/BulletPoints';
import { parsePricingSelectorV2Accordions } from './components/PricingSelectorV2Accordions/PricingSelectorV2Accordions.parser';
import { PricingSelectorV2Props } from './PricingSelectorV2';

export function parsePricingSelectorV2(
  section: Queries.ContentfulSection001,
): PricingSelectorV2Props {
  const { eyebrow, metadata } = section;

  const subsections =
    section?.subsections as Queries.ContentfulPriceSection001[];

  const priceCards = filterSubsectionsByName('PriceV2Cards', subsections);

  const priceSections = priceCards?.map((priceCard) => {
    const flags: readonly Queries.Maybe<Queries.ContentfulFlag001>[] =
      priceCard.flags || ([] as any);

    const isVisible = flags?.find(
      (flag) => flag?.displayText === 'isVisible',
    )?.value;

    const priceDetail = priceCard?.priceDetail || {};

    const secondaryCard = priceCard?.secondaryCard || {};

    const accordions = parsePricingSelectorV2Accordions(priceCard?.accordions);

    const cta = priceCard?.cta;

    return {
      // TODO: Parse these empty objects
      priceDetail,
      bulletPoints: {} as BulletPointsProps,
      cta: {
        label: cta?.label || '',
        metadata: cta?.metadata || {},
        url: cta?.url || '',
      },
      isVisible,
      secondaryCard,
      accordions,
    };
  });

  return {
    eyebrow,
    title: metadata?.title || '',
    // TODO: Remove this ignore after updating the type
    // @ts-ignore
    priceSections: priceSections || [],
  };
}
